module.exports = __webpack_public_path__ + "img/discussion_vote_heart.7f9302fb.svg";